import { toggleMark } from 'prosemirror-commands';
import { CommandProps } from '../types';
import { BaseMark } from './base/BaseMark';

export class Code extends BaseMark {
  constructor() {
    super('code');
  }

  get schema() {
    return {
      code: true,
      parseDOM: [{ tag: 'code' }],
      toDOM() {
        return ['code', 0] as const;
      },
    };
  }

  commands({ schema }: CommandProps) {
    return {
      'Mod-Shift-c': toggleMark(schema.marks.code),
    };
  }
}
